import { render, staticRenderFns } from "./401-page.vue?vue&type=template&id=45c8be00&scoped=true"
import script from "./401-page.vue?vue&type=script&lang=js"
export * from "./401-page.vue?vue&type=script&lang=js"
import style0 from "./401-page.vue?vue&type=style&index=0&id=45c8be00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c8be00",
  null
  
)

export default component.exports